// ═══════════════════════════════════════════════════════════
//  CONFIGURAÇÃO DA HOME — edite aqui à vontade!
//  Não é necessário mexer em nenhum outro arquivo.
//
//  CARROSSEL: adicione ou remova slides do array abaixo.
//  SHORTS: cole links de Reels/YouTube quando tiver.
//  AGENDA: adicione eventos do mês (só aparecem se tiver algo).
// ═══════════════════════════════════════════════════════════

// ─── CARROSSEL DE DESTAQUES ────────────────────────────────
// Cada slide pode ter:
//   titulo    → texto principal (obrigatório)
//   subtitulo → linha menor acima do título (opcional)
//   imagem    → URL da imagem de fundo (ou null para usar corFundo)
//   corFundo  → cor sólida usada quando não há imagem
//   cta       → texto do botão (opcional)
//   link      → URL para onde o botão leva (opcional)

export const carrosselSlides = [];

// ─── SHORTS DO CLUBE ───────────────────────────────────────
// Cards de vídeos curtos (Reels, YouTube Shorts, etc.)
// A seção fica OCULTA automaticamente se este array estiver vazio.
// Cada item pode ter:
//   id        → identificador único
//   titulo    → texto embaixo do card
//   thumbnail → URL da imagem de capa (ou null para placeholder)
//   link      → URL do Reel/post

export const shortsDoClube = [];

// ─── AGENDA DO MÊS ─────────────────────────────────────────
// A seção fica OCULTA automaticamente se não houver eventos futuros.
// Cada evento pode ter:
//   id    → identificador único
//   titulo → nome do evento
//   data  → formato 'DD/MM/AAAA' (ex: '20/04/2026')
//   tipo  → 'live' | 'aula' | 'lancamento'
//   link  → URL para inscrição/participação (opcional)

export const agendaDoMes = [
  // Exemplo — descomente e preencha quando tiver:
  // {
  //   id: 'live-abril',
  //   titulo: 'Live: Meditação guiada ao vivo',
  //   data: '20/04/2026',
  //   tipo: 'live',
  //   link: '',
  // },
];
